import { ProfessionalTypeEnum } from '@gql/graphql';
import type { SelectOption } from '@presentation/components';
import { InputLabel, InputRadio, InputWrapper } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { useMemo } from 'react';
import { BiIdCard } from 'react-icons/bi';
import activeEducatorSvg from '../../assets/activeEducator.svg';
import activeGroomerSvg from '../../assets/activeGroomer.svg';
import activeVeterinarianSvg from '../../assets/activeVet.svg';
import educatorSvg from '../../assets/educator.svg';
import groomerSvg from '../../assets/groomer.svg';
import veterinarianSvg from '../../assets/vet.svg';
import * as Styled from './styled';
import type { ProRadioInputProps } from './types';

export const ProRadioInput: FC<ProRadioInputProps> = (props) => {
  const { proSearch } = props;
  const { translate } = useTranslation();

  const options: SelectOption<ProfessionalTypeEnum>[] = useMemo(() => {
    return proSearch.options.proType.map((option) => {
      let src =
        proSearch.values.proType === ProfessionalTypeEnum.VET
          ? activeVeterinarianSvg
          : veterinarianSvg;
      if (option.value === ProfessionalTypeEnum.GROOMER) {
        src =
          proSearch.values.proType === ProfessionalTypeEnum.GROOMER ? activeGroomerSvg : groomerSvg;
      } else if (option.value === ProfessionalTypeEnum.EDUCATOR) {
        src =
          proSearch.values.proType === ProfessionalTypeEnum.EDUCATOR
            ? activeEducatorSvg
            : educatorSvg;
      }
      return {
        value: option.value,
        label: (
          <Styled.LabelContainer>
            <Styled.Icon src={src} size={40} />
            {translate(`enum.proType.${option.value}`)}
          </Styled.LabelContainer>
        ),
      } as SelectOption<ProfessionalTypeEnum>;
    });
  }, [proSearch.options.proType, translate, proSearch.values.proType]);

  return (
    <InputWrapper>
      <InputLabel icon={<BiIdCard />}>
        {translate('common.inputs.professionnalType.label')}
      </InputLabel>
      <InputRadio<ProfessionalTypeEnum>
        grow
        autoHeight
        value={proSearch.tempValues.proType ?? proSearch.values.proType}
        onSelect={(selected) => {
          proSearch.fieldSelectHandler({ type: 'proType', value: selected });
        }}
        options={options}
      />
    </InputWrapper>
  );
};
